import React, { useEffect } from 'react';
import { drawHistogramChart } from '@cardiacsense/cs-charts-module';
import { AtrialFibrillation, AtrialFibrillationBox } from './atrial-fibrillation';
import moment from 'moment';
import { pdf_chart_height, pdf_width, print_height, print_width } from '../consts';
import { fakeEcgDataForProportionSign } from '../utils/general-utils';
import { useWindowSize } from '../hooks/useOnResize';
import CreateChart from './monthlySummaryChart';
function AfCharts({ afChartsData, isPdf }) {
    const { histogram_data, histogram_data: { histogram_during_af, histogram_not_during_af }, af_data, af_detection_summary_data } = afChartsData;
    const [width] = useWindowSize();
    useEffect(() => {
        drawAfCharts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [width]);
    const histogramChart = () => ({
        "af-report-chart": { draw: drawHistogramChart, data: [histogram_during_af] },
        "no-af-report-chart": { draw: drawHistogramChart, data: [histogram_not_during_af] },
    });
    const drawAfCharts = () => {
        const charts = histogramChart();
        Object.keys(charts).forEach(type => {
            var _a, _b, _c, _d, _e, _f, _g;
            const { draw, data } = charts[type];
            if (type === 'ecg-report-chart') {
                //this inject fake data for drawing a proportion sign
                ((_e = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.ecg_ppg) === null || _b === void 0 ? void 0 : _b.ecg_ppg_strips_sorted) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.strips) === null || _e === void 0 ? void 0 : _e[0]) &&
                    (data[0].ecg_ppg.ecg_ppg_strips_sorted[0].strips[0] = fakeEcgDataForProportionSign(1));
            }
            const chartNode = document.getElementsByClassName(`${type}`)[0];
            const width = type === 'ecg-report-chart' ? isPdf ? pdf_width : window.innerWidth - (window.innerWidth / 15) : 570;
            let height = pdf_chart_height; //isPdf ? pdf_chart_height : chart_height
            if (type === 'ecg-report-chart')
                height = width / 4;
            const chartSVG = draw(...data, {}, (date) => window.open(`/static/reports/af-report/${moment(date).format('YYYY-MM-DD')}`, "_blank"), width, height, type);
            // draw the same chart beat smaller for printing in portal
            let chartSVGPrint;
            if (!isPdf) {
                const printWidth = type === 'ecg-report-chart' ? print_width : 570;
                chartSVGPrint = draw(...data, {}, (date) => window.open(`/static/reports/af-report/${moment(date).format('YYYY-MM-DD')}`, "_blank"), printWidth, print_height - 100, type);
            }
            function isNode(e) {
                return (typeof Node === "object" ? e instanceof Node :
                    e && typeof e === "object" && typeof e.nodeType === "number" && typeof e.nodeName === "string");
            }
            if (chartSVG.length > 1) {
                if ((_f = chartNode.children) === null || _f === void 0 ? void 0 : _f.length)
                    chartNode.innerHTML = ''; //avoid duplications
                chartSVG.map((m, index, arr) => {
                    if (isNode(m)) {
                        const wrapBrowserChart = document.createElement('div');
                        wrapBrowserChart.setAttribute('class', `${!isPdf ? 'print-hide' : ''} pdf-cut-guard`);
                        wrapBrowserChart.appendChild(m);
                        chartNode === null || chartNode === void 0 ? void 0 : chartNode.appendChild(wrapBrowserChart);
                    }
                });
                if (chartSVGPrint) {
                    chartSVGPrint.map((m, index, arr) => {
                        if (isNode(m)) {
                            const wrapPrintChart = document.createElement('div');
                            wrapPrintChart.setAttribute('class', 'print-show pdf-cut-guard');
                            wrapPrintChart.appendChild(m);
                            chartNode === null || chartNode === void 0 ? void 0 : chartNode.appendChild(wrapPrintChart);
                        }
                    });
                }
            }
            else {
                isNode(chartSVG) && !((_g = chartNode.children) === null || _g === void 0 ? void 0 : _g.length) && (chartNode === null || chartNode === void 0 ? void 0 : chartNode.appendChild(chartSVG));
            }
        });
    };
    const headings = {
        'af-report-chart': 'Minute Pulse Rate distribution during AF',
        'no-af-report-chart': 'Minute Pulse Rate distribution during non AF',
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: 'pdf-cut-guard page-break' },
            React.createElement(AtrialFibrillation, { af_data: af_data, histogramData: histogram_data }),
            React.createElement("div", { className: 'pt-5 d-flex pdf-cut-guard wrap-histogram-charts' }, Object.keys(headings).map(type => React.createElement("div", { key: type, className: 'pdf-cut-guard fs-1 histogram-chart' },
                React.createElement("div", { className: 'fs-4 grey-team histogram-chart-title' }, headings[type]),
                React.createElement("div", { className: type, key: type })))),
            React.createElement(AtrialFibrillationBox, { af_data: af_data, histogramData: histogram_data })),
        React.createElement("div", { className: "card-header bg-transparent page-break", style: { padding: '0.85rem 1.5rem' } },
            React.createElement("div", { className: "row header-card" }, "Monthly Summary")),
        React.createElement("div", { className: `${!isPdf ? 'print-hide' : ''} pdf-cut-guard`, style: { width: isPdf ? pdf_width : window.innerWidth - (window.innerWidth / 15) } },
            React.createElement(CreateChart, { af_detection_summary_data: af_detection_summary_data, type: "monthly-summery-chart" })),
        !isPdf && React.createElement("div", { className: "", style: { width: print_width } },
            React.createElement(CreateChart, { af_detection_summary_data: af_detection_summary_data, type: "monthly-summery-chart-print" }))));
}
export default AfCharts;
